import { EntityState, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { Cart } from 'projects/cart-tv/src/app/data/cart';
import { AbstractUiEntityStore } from 'projects/app-misc/src/app/modules/data/abstract-ui-entity.store';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';
import { CartScan } from './cart-scan';
import { Tray } from './tray';

export interface CartsState extends EntityState<Cart, number> {
  ui: {
    lastScan: Tray,
    deletedCart: number
  };

}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({name: 'carts-store'})
export class CartsStore extends AbstractUiEntityStore<CartsState> {
  allProjects: ShortProject[];

  constructor() {
    super({
      ui: {
        lastScan: null,
        deletedCart: null
      }
    });
  }

  addPart(tray: Tray) {
    this.updateUi({
      ...this._value().ui,
      lastScan: tray
    })

    this.updateUi({
      ...this._value().ui,
      lastScan: null
    })

  }

  updateAllProjs(projs) {
    this.allProjects = projs
  }

  deleteCart(cartId: number) {
    this.updateUi({
      ...this._value().ui,
      deletedCart: cartId
    })

  }

}
